import { useState } from "react";
import { motion } from "framer-motion";
import { Feather } from "lucide-react";
import { openQuote } from "../lib/site";

const TYPES = [
  { k: "Final Expense", d: "Small, affordable whole-life policies that cover funeral and end-of-life costs, so loved ones aren't left with the bill. Often simplified issue." },
  { k: "IUL", d: "Indexed Universal Life: lifelong coverage with cash value growth linked to a market index, with downside protection and flexible premiums." },
  { k: "Whole Life", d: "Guaranteed level premiums, guaranteed death benefit and cash value that grows steadily for as long as you live." },
];

export const LifeCard = ({ Card }) => {
  const [active, setActive] = useState(0);
  return (
    <Card testid="bento-life" delay={0.04} className="md:col-span-2 lg:col-span-5 lg:row-span-2 bg-[#0B281E] text-[#FAF8F5] p-7 lg:p-9 flex flex-col min-h-[460px]">
      <div className="absolute -right-24 -top-24 w-72 h-72 rounded-full border border-[#E5A855]/20" />
      <div className="absolute -right-10 -top-10 w-44 h-44 rounded-full border border-[#E5A855]/20" />
      <Feather className="w-8 h-8 text-[#E5A855]" />
      <p className="font-mono-d text-xs uppercase tracking-[0.25em] text-[#E5A855] mt-8">Life Insurance</p>
      <h3 className="font-serif-d text-4xl lg:text-5xl mt-3 leading-[1.02]">Love, put in <em className="text-[#E5A855]">writing.</em></h3>
      <div className="mt-8 flex gap-2 flex-wrap" role="tablist">
        {TYPES.map((t, i) => (
          <button key={t.k} role="tab" aria-selected={active === i} onClick={() => setActive(i)} data-testid={`life-tab-${i}`}
            className={`relative rounded-full px-4 py-2 text-sm transition-colors ${active === i ? "text-[#071510]" : "text-[#F4F1EA]/80 hover:text-white border border-white/20"}`}>
            {active === i && <motion.span layoutId="lifepill" className="absolute inset-0 rounded-full bg-[#E5A855]" transition={{ type: "spring", stiffness: 300, damping: 30 }} />}
            <span className="relative">{t.k}</span>
          </button>
        ))}
      </div>
      <motion.p key={active} initial={{ opacity: 0.2, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45 }} className="mt-6 text-[#F4F1EA]/85 leading-relaxed min-h-[96px]" data-testid="life-tab-description">
        {TYPES[active].d}
      </motion.p>
      <button onClick={() => openQuote("life")} data-testid="life-quote-btn" className="mt-auto pt-6 self-start text-sm font-semibold text-[#E5A855] underline underline-offset-8 decoration-[#E5A855]/40 hover:decoration-[#E5A855]">Compare life policies →</button>
    </Card>
  );
};
